/**
 * 首页-教模块
 */
import { request } from 'hxhy-axios'
import { apiList as api } from './apiList'
// 根据机构id获取机构下的学校
export function getSchoolList(params) {
  return request({
    url: api.indexJiao.getSchoolList,
    method: 'get',
    params,
  })
}

// 获取字典项列表
export function getDictItem(code) {
  return request({
    url: api.indexJiao.getDictItem + code,
    method: 'get',
  })
}

// 互动课堂统计分析数据列表
export function getList(data) {
  return request({
    url: api.indexJiao.getList,
    method: 'post',
    data,
  })
}

// 课堂展示-获取查询条件
export function getWeekLesson(data) {
  return request({
    url: api.indexJiao.getWeekLesson,
    method: 'post',
    data,
  })
}
// 课堂展示-获取查询条件
export function getMonthLesson(data) {
  return request({
    url: api.indexJiao.getMonthLesson,
    method: 'post',
    data,
  })
}
// 根据课堂ID获取小组提交作品数据
export function getTeamWorkByLessonId(params) {
  return request({
    url: api.indexJiao.getTeamWorkByLessonId,
    method: 'get',
    params,
  })
}

/**
 * 班级下拉框-教师
 */
export function getClassTeacher(data) {
  return request({
    url: api.indexJiao.teacherGetClass,
    method: 'get',
    params: data,
  })
}
/**
 * 时间周期-教师
 */
export function getTimeTeacherPeriod() {
  return request({
    url: api.indexJiao.teacherGetCycles,
    method: 'get',
  })
}

/**
 * 导出教师数据
 */
export function exportTeacherData(data) {
  return request({
    url: api.indexJiao.teacherGroupDataSheetExport,
    method: 'get',
    params: data,
    responseType: 'blob',
  })
}

/**
 * 小组下拉框
 */
export function getGroupTeacher(data) {
  return request({
    url: api.indexJiao.teacherGetGroup,
    method: 'get',
    params: data,
  })
}
/**
 * 学生下拉框-教师
 */
export function getStudentTeacher(data) {
  return request({
    url: api.indexJiao.teacherGetStudent,
    method: 'get',
    params: data,
  })
}
/**
 * 教师授课详情-教师
 */
export function getGroupAndMemberDetail(data) {
  return request({
    url: api.indexJiao.groupDataSheet,
    method: 'get',
    params: data,
  })
}

/**
 * 互动与参与
 */
export function getInteractionAndParticipation(data) {
  return request({
    url: api.indexJiao.interactionAndParticipation,
    method: 'get',
    params: data,
  })
}
